<template>
    <div
        class="w-screen lg:w-[22rem] bg-white border border-gray-100 shadow-2xl rounded-t-lg transition-all duration-300 overflow-hidden"
        :class="`${isChatOpen ? 'h-screen lg:h-[35rem]' : 'h-0'}`"
    >
        <div class="flex flex-col h-full">
            <div class="border-b border-gray-200">
                <div
                    class="flex justify-center sm:justify-start lg:justify-between items-center p-4"
                >
                    <div class="flex items-center gap-2 truncate mr-4">
                        <button
                            class="bg-gray-100 items-center text-gray-300 dark:text-gray-600 px-4 py-[0.4375rem] lg:!p-0 lg:w-auto text-lg font-medium rounded-3xl leading-4 h-[2.5rem] w-[2.5rem] xs:h-[2rem] xs:w-[2rem] xs:px-0 justify-center dark:bg-black-900 absolute left-4 flex lg:hidden"
                            @click="emits('handleMinimizeChat')"
                        >
                            <fa
                                :icon="['fal', 'chevron-left']"
                                class="!text-lg text-gray-300"
                            />
                        </button>
                        <div
                            v-if="contactGroup.contacts?.length"
                            class="truncate flex-1 mx-14 sm:mx-0 sm:ml-14 sm:mr-4 lg:mx-0"
                        >
                            <MutliContactNameIcon
                                :data="contactGroup.contacts || []"
                                badge-class="!bg-[#FF5EAB] z-0"
                                :is-large="true"
                                :is-show="true"
                            />
                        </div>
                        <div
                            v-for="(label, index) in chatLabels"
                            :key="index"
                            class="hidden lg:block"
                        >
                            <AppLabel
                                :label-text="label.name"
                                :classes="label.color"
                            />
                        </div>

                        <div class="hidden sm:block lg:hidden">
                            <StepLabels
                                :data="label"
                                @manage-labels="null"
                                @check-label-value="null"
                                @handle-click="null"
                            />
                        </div>
                    </div>

                    <div class="items-center gap-4 hidden lg:flex">
                        <fa
                            :icon="['fal', 'tag']"
                            class="text-gray-300 text-2xl cursor-pointer"
                        />
                        <fa
                            :icon="['fal', 'minus']"
                            class="text-gray-300 text-2xl cursor-pointer"
                            @click="() => emits('handleMinimizeChat')"
                        />
                        <fa
                            :icon="['fal', 'xmark']"
                            class="text-gray-300 text-2xl cursor-pointer"
                            @click="
                                () => emits('handleCloseChat', contactGroup)
                            "
                        />
                    </div>
                </div>
            </div>
            <div class="flex items-center justify-between p-4 b sm:hidden">
                <div>
                    <StepLabels
                        :data="label"
                        @manage-labels="null"
                        @check-label-value="null"
                        @handle-click="null"
                    />
                </div>

                <div class="flex items-center gap-2">
                    <button class="close" @click="null">
                        <fa :icon="['fal', 'inbox-in']" class="mr-2" />
                        <span>Close</span>
                    </button>
                    <button
                        class="flex bg-gray-100 items-center text-gray-300 dark:text-gray-600 px-4 py-[0.4375rem] lg:!p-0 lg:w-auto text-lg font-medium rounded-3xl leading-4 h-[2.5rem] w-[2.5rem] xs:h-[2rem] xs:w-[2rem] xs:px-0 justify-center dark:bg-black-900"
                    >
                        <fa
                            :icon="['fal', 'gear']"
                            class="!text-lg text-gray-300"
                        />
                    </button>
                </div>
            </div>
            <div class="border-b border-gray-200">
                <div class="bg-gray-100 text-xs text-center font-normal py-2">
                    <p>Anna & Yuri have disabled WhatsApp</p>
                    <!-- Contact's that have blocked whatsapp should be filtered by is_whatsapp key from contacts in contactGroup -->
                </div>
            </div>
            <div class="justify-end py-4 px-6 hidden sm:flex lg:hidden">
                <div class="flex items-center gap-4">
                    <button class="close !rounded-lg" @click="null">
                        <fa :icon="['fal', 'inbox-in']" class="mr-2" />
                        <span>Close</span>
                    </button>
                    <fa
                        :icon="['far', 'search']"
                        class="!text-lg text-gray-300"
                    />
                    <fa
                        :icon="['far', 'ellipsis']"
                        class="!text-lg text-gray-300"
                    />
                </div>
            </div>
            <div
                ref="chatBoxMessages"
                class="flex-1 overflow-y-auto hide-scroll"
            >
                <div
                    v-if="loadingStates.chat"
                    class="flex mt-6 justify-center items-center gap-2"
                >
                    <div
                        class="w-6 h-6 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"
                    ></div>

                    <span class="font-semibold">Loading ...</span>
                </div>

                <div v-else class="py-4 px-2 flex flex-col gap-4">
                    <template
                        v-for="(chat, index) in currentChatMessages"
                        :key="index"
                    >
                        <p
                            class="chatTime text-xs text-center w-full text-gray-500 mb-6 font-light"
                        >
                            {{
                                chat._id === moment().format('YYYY-MM-DD')
                                    ? 'Today'
                                    : chat._id
                            }}
                        </p>
                        <div v-for="(message, index) in chat.docs" :key="index">
                            <ChatMessage
                                :is_agent="message.sender.role === 'Agent'"
                                :message="message || 'Something went wrong!'"
                                :offer-letter="false"
                                :message_time="message.updatedAt"
                                :is_read="message.chat?.users.length === message?.readBy.length"
                                size="sm"
                            />
                        </div>
                    </template>
                </div>
            </div>

            <div class="border-t border-gray-200">
                <input id="attach_file_chatbox" type="file" v-show="false" multiple @change="sendFile" />
                <Preview
                    v-if="toPreview"
                    :file-type="file_type"
                    :data="SelectedBotData"
                    @toggle-preview="togglePreview"
                    @send-selected-bot="sendBotMessage"
                    :hasSendButton="false"
                />
                <div v-else-if="fileAttachments.length" tabindex="0" @keyup.enter="sendFile" class="flex items-center gap-4 overflow-x-auto mb-4">
                    <div
                        v-for="(attachment, index) in fileAttachments"
                        :key="index"
                        class="relative overflow-visible my-3 min-w-[12rem]"
                    >
                        <div
                            class="w-5 h-5 rounded-full flex items-center justify-center bg-slate-50 border border-gray-100 absolute top-0 right-0 translate-x-1/2 -translate-y-1/2"
                            @click="() => handleRemoveAttachment(index)"
                        >
                            <fa class="text-xs cursor-pointer" :icon="['fal', 'close']"></fa>
                        </div>
                        <img :src="attachment.url" class="w-full h-20 object-cover shadow-sm" />
                    </div>
                </div>
                <div v-else>
                    <div
                        v-if="typingInput && typingInRoom === contactGroup.chatId"
                        class="text-xs px-1 py-1 text-blue-500"
                    >
                        typing...
                    </div>
                    <div class="items-center gap-2 lg:p-4 hidden lg:flex">
                        <AppDropdown>
                            <AppDropdownList :gray="true" placement="bottom-end">
                                <template #dropdownBtn>
                                    <!-- <app-button
                                        icon="plus"
                                        iconType="fal"
                                        color="secondary"
                                        class="h-8 !text-xl"
                                        btnClass="!bg-transparent !border-none"
                                    /> -->
                                    <fa :icon="['fal', 'plus']" class="text-gray-300 text-2xl" />
                                </template>
                                <template #content="{ hide }">
                                    <div class="flex flex-col gap-2 py-2 px-0 w-96">
                                        <ul class="">
                                            <li
                                                class="flex items-center justify-between gap-1 cursor-pointer p-2 hover:bg-gray-100 rounded-lg"
                                            >
                                                <div class="flex gap-1">
                                                    <fa :icon="['fal', 'file-pen']" class="text-gray-300 text-lg" />
                                                    Canned response
                                                </div>
                                            </li>
                                            <li
                                                class="flex items-center justify-between gap-1 cursor-pointer p-2 hover:bg-gray-100 rounded-lg"
                                                @click="handleBotFetch"
                                            >
                                                <SendBotsDropdown
                                                    :botsArray="botsArray"
                                                    :sendBotMessage="handleBotSelect"
                                                >
                                                    <fa :icon="['fal', 'message-bot']" class="text-gray-300 text-lg" />
                                                    Trigger Bots
                                                </SendBotsDropdown>
                                            </li>
                                            <li
                                                class="flex items-center justify-between gap-1 cursor-pointer p-2 hover:bg-gray-100 rounded-lg"
                                            >
                                                <div class="flex gap-1" @click="attachFile">
                                                    <fa :icon="['fal', 'paperclip']" class="text-gray-300 text-lg" />
                                                    Add attachment
                                                </div>
                                            </li>
                                            <li
                                                class="flex items-center justify-between gap-1 cursor-pointer p-2 hover:bg-gray-100 rounded-lg"
                                                >
                                                <EmojiDropdown :attach-emoji>
                                                    <fa
                                                        :icon="['fal', 'face-smile']"
                                                        class="cursor-pointer !text-[20px] !font-[300] !leading-normal text-gray-300 text-lg"
                                                    /> Emojis
                                                </EmojiDropdown>
                                            </li>
                                        </ul>
                                    </div>
                                </template>
                            </AppDropdownList>
                        </AppDropdown>

                    <input
                        id="messageInput"
                        ref="messageInput"
                        v-model="typedMessage"
                        class="bg-gray-100 border border-white focus:border-gray-200 outline-none rounded-full px-4 py-2 flex-1"
                        placeholder="Enter message here..."
                        :disabled="loadingStates.message"
                        @keydown.enter.prevent="handleSendMessage"
                        @keypress="getKeyEvents"
                    />
                </div>
                <div class="block lg:hidden">
                        <!-- <ChatInput
                            :input="typedMessage"
                            :is-loading="loadingStates.message"
                            @handle-send-message="handleSendMessage"
                            @handle-input="(e) => (typedMessage = e)"
                        /> -->

                        <SendBox
                            ref="sendBoxRef"
                            :canned-detail="cannedDetail"
                            :canned-status="cannedStatus"
                            @close-canned-response="cannedStatus = false"
                            @show-canned-reponse="handleCannedReponse"
                            @show-full-screen="showFullScreenReplyModal()"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { computed, nextTick, onMounted, onUnmounted, ref, watch } from 'vue';
import moment from 'moment/moment';
import { getConversation } from '@/api/AppChatServices';
import {
    establishSocketConn,
    getAllRoomMessages,
    getBotJson, 
    getBots,
    getChatLabelsMethod,
    getKeyEvents,
    sendBotMessage, 
    sendFile,
    sendMessage,
} from '@/api/ChatServices';
import { chatroomStore } from '@/stores/messagesStore';
import { useLabelsStore } from '@/stores/labels';
import { socketConn } from '@/stores/socketConn';
import ChatMessage from '@/components/appComponents/chat/ChatMessage.vue';
import AppLabel from '@/components/appComponents/AppLabel.vue';
import MutliContactNameIcon from '@/components/contacts/MutliContactNameIcon.vue';
import AppDropdown from '@/components/dropdown/AppDropdown.vue';
import AppDropdownList from '@/components/dropdown/AppDropdownList.vue';
import StepLabels from '@/components/contacts/StepLabels.vue';
import AppButton from '@/components/AppButton.vue';
import SendBotsDropdown from "@/components/settings/inbox/inbox-component/dropdowns/SendBotsDropdown.vue";
import EmojiDropdown from "@/components/settings/inbox/inbox-component/dropdowns/EmojiDropdown.vue";
import Preview from "@/components/settings/inbox/inbox-component/Preview.vue";
import SendBox from "@/components/settings/inbox/inbox-component/SendBox.vue";
import ChatInput from './chatInput.vue';

const chatLabels = ref([]);

const emits = defineEmits(['handleCloseChat', 'handleMinimizeChat']);
const props = defineProps({
    isChatOpen: {
        type: Boolean,
        default: false,
    },
    contactGroup: {
        type: Object,
        default: {},
    },
});

// [info]: ELEM
const messageInput = ref(null);
const chatBoxMessages = ref(null);
const pageSize = ref(50);
const pageSkip = ref(0);
const typingTimeout = ref(null);

// [info]: states
const typedMessage = ref("");
const loadingStates = ref({
    chat: false,
    message: false,
});
const messages = ref([]);
const typingInRoom = ref(null);
const typingInput = ref(false);
const botsArray = ref(false);
const toPreview = ref(false);
const SelectedBotData = ref({});
const fileAttachments = ref([]);
const sendBoxRef = ref(null);

// [info]: methods
const handleSendMessage = async () => {
    loadingStates.value.message = true;
    try {
        const payload = {
            isNote: false,
            chatRoomId: props.contactGroup.chatId,
            content: typedMessage.value,
        };
        const { data } = await sendMessage(payload);
        await getAllRoomMessages({
            chatRoomId: props.contactGroup.chatId,
            pageSkip: 0,
        });
        messages.value = data;
    } catch (e) {
        console.error(e);
    } finally {
        loadingStates.value.message = false;
        typedMessage.value = '';
        handleScrollToBottom(() => {
            messageInput.value.focus();
        });
    }
};

const handleGetConversation = async (contactGroup) => {
    loadingStates.value.chat = true;
    chatLabels.value = chatroomStore.chatLabels[contactGroup.chatId];
    try {
        const { data } = await getConversation();
        const LabelsStore = useLabelsStore();
        // messages.value = data;
        const payload = {
            chatRoomId: contactGroup.chatId,
            pageSize: pageSize.value,
            pageSkip: pageSkip.value,
        };
        await getAllRoomMessages(payload);
        if (chatroomStore.activeChatContact?.labels?.length > 0) {
            await getChatLabelsMethod();
            chatroomStore.chatLabels[contactGroup.chatId] =
                LabelsStore.getLabelsByIds(
                    chatroomStore.activeChatContact.labels
                );
        }
    } catch (e) {
        console.error(e);
    } finally {
        loadingStates.value.chat = false;
        handleScrollToBottom();
    }
};

const handleScrollToBottom = (func) => {
    nextTick(() => {
        if (chatBoxMessages.value)
            chatBoxMessages.value.scrollTo({
                top: chatBoxMessages.value.scrollHeight,
                behavior: 'smooth',
            });

        if (func) func();
    });
};

const currentChatMessages = computed(() => {
    return chatroomStore.message[props.contactGroup.chatId] || [];
});

const handleBotFetch = async () => {
    botsArray.value = await getBots();
};

const handleBotSelect = async (selectedBotId = null) => {
    togglePreview();
    let botJson = await getBotJson(selectedBotId);
    SelectedBotData.value = {
        id: botJson.id,
        name: botJson.name,
        text: botJson.data[1]?.data["modelValText"],
        buttons: botJson.data[1]?.data["actionButtons"],
    };
};
const togglePreview = () => {
    toPreview.value = !toPreview.value;
};

const attachFile = () => {
    document.getElementById("attach_file_chatbox").click();
};

const handleChange = (event) => {
    const newAttachments = Array.from(event.target.files).map((file) => ({
        file,
        url: URL.createObjectURL(file),
    }));
    fileAttachments.value = [...fileAttachments.value, ...newAttachments];
    document.getElementById("attach_file_chatbox").focus();
};

const handleRemoveAttachment = (index) => {
    fileAttachments.value.splice(index, 1);
};

onMounted(async () => {
    if (!socketConn.socket?.connected) {
        await establishSocketConn();
    }
    socketConn.socket.on('typing', (roomID) => {
        if (roomID === props.contactGroup.chatId) {
            typingInRoom.value = roomID;
            typingInput.value = true;
        }
    });

    socketConn.socket.on('stop typing', (roomID) => {
        if (roomID === props.contactGroup.chatId) {
            typingInRoom.value = roomID;
            typingInput.value = false;
        }
    });
});

const attachEmoji = (emoji) => {
    if (emoji) {
        typedMessage.value += emoji;
        document.getElementById("messageInput").focus();
    }
};

watch(
    () => chatroomStore.message[props.contactGroup.chatId],
    (current) => {
        messages.value = current || [];
        handleScrollToBottom(() => {
            messageInput.value.focus();
        });
    },
);

onUnmounted(() => {
    if (socketConn.socket) {
        socketConn.socket.off("typing");
        socketConn.socket.off("stop typing");
        clearTimeout(typingTimeout.value);
    }
});

defineExpose({ handleGetConversation });
</script>

<style scoped>
.close {
    display: flex;
    height: 32px;
    padding: 10px 12px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #dde3e4;
    background: #000;
    color: #fff;
    border-radius: 200px;

    /* Small button */
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}
</style>
